import type { OpportunityCatalogs } from '@/pages/Opportunities/types';
import type { TextFieldName } from '@/pages/Opportunities/formSchema';

export interface OpportunityFieldDefinition {
    name: TextFieldName; type?: 'text' | 'date' | 'time' | 'decimal' | 'textarea';
    required?: boolean; catalog?: keyof OpportunityCatalogs;
}
export const opportunityFormSections: { key: string; fields: OpportunityFieldDefinition[] }[] = [
    { key: 'planning', fields: [
        { name: 'title', required: true }, { name: 'submission_date', type: 'date', required: true }, { name: 'submission_time', type: 'time', required: true },
        { name: 'submission_timezone', required: true }, { name: 'external_reference' }, { name: 'submission_mode' }, { name: 'responsible_id', catalog: 'responsibles' },
    ] },
    { key: 'work', fields: [
        { name: 'description', type: 'textarea' }, { name: 'project_type_id', catalog: 'project_types' }, { name: 'address' }, { name: 'street_number' }, { name: 'postal_code' },
        { name: 'city', required: true }, { name: 'province_id', catalog: 'provinces', required: true }, { name: 'country_id', catalog: 'countries' },
    ] },
    { key: 'economics', fields: [
        { name: 'budget', type: 'decimal', required: true }, { name: 'general_expenses_percentage', type: 'decimal' }, { name: 'industrial_profit_percentage', type: 'decimal' },
        { name: 'vat_percentage', type: 'decimal' }, { name: 'provisional_guarantee_percentage', type: 'decimal' }, { name: 'definitive_guarantee_percentage', type: 'decimal' },
        { name: 'contractor_expenses', type: 'decimal' }, { name: 'contractor_expenses_description', type: 'textarea' }, { name: 'payment_method_id', catalog: 'payment_methods' },
        { name: 'subcontracting_percentage', type: 'decimal' },
    ] },
    { key: 'valuation', fields: [
        { name: 'valuation_criteria', type: 'textarea', required: true }, { name: 'deadline_period', required: true }, { name: 'deadline_unit_id', catalog: 'deadline_units', required: true },
        { name: 'designer' }, { name: 'annuities' },
    ] },
    { key: 'notes', fields: [{ name: 'observations', type: 'textarea' }] },
];
